// extracted by mini-css-extract-plugin
export var actions = "_ut-4";
export var item = "_ut-1";
export var price = "_ut-3";
export var quantity = "_ut-2";
export var table = "_ut-0";